import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const CurrencyContext = createContext(null);
export const useCurrency = () => useContext(CurrencyContext);

export function CurrencyProvider({ children }) {
  const [config, setConfig] = useState({ base: "USD", currencies: { USD: { symbol: "$", rate: 1, name: "US Dollar" } } });
  const [currency, setCurrency] = useState(() => localStorage.getItem("dw_currency") || "USD");
  const [region, setRegion] = useState(null);

  useEffect(() => {
    api.get("/currency/config").then(({ data }) => setConfig(data)).catch(() => {});
    if (!localStorage.getItem("dw_currency")) {
      api.get("/region/detect").then(({ data }) => {
        setRegion(data);
        if (data.currency) {
          setCurrency(data.currency);
          localStorage.setItem("dw_currency", data.currency);
        }
      }).catch(() => {});
    }
  }, []);

  const changeCurrency = useCallback((code) => {
    setCurrency(code);
    localStorage.setItem("dw_currency", code);
  }, []);

  const format = useCallback((usd) => {
    const c = config.currencies?.[currency] || { symbol: "$", rate: 1 };
    const val = (usd || 0) * c.rate;
    const isJPY = currency === "JPY";
    const num = isJPY ? Math.round(val).toLocaleString() : val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return `${c.symbol}${num}`;
  }, [config, currency]);

  return (
    <CurrencyContext.Provider value={{ config, currency, changeCurrency, format, region }}>
      {children}
    </CurrencyContext.Provider>
  );
}
